<!-- <p>incident-dashboard-table works!</p> -->
<mat-card
  [ngClass]="{
    'incident-table-card':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'incident-table-card-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card-header *ngIf="false" class="incident-table-card-header">
    <div
      [ngClass]="{
        'incident-table-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
        'incident-table-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      <div
        [ngClass]="{
      'incident-table-header-inner': screenSize == ScreenType.Mobile,
      'incident-table-header-inner-desktop':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    }"
      >
        <!-- <h2>RECENT INCIDENTS</h2> -->
        <div
          *ngIf="role == 'security'"
          class="manual-add"
          (click)="onCreateManualEvent()"
        >
          <mat-icon>add_circle_outline</mat-icon>
          <h4>CREATE MANUAL EVENT</h4>
        </div>

        <mat-form-field
          appearance="outline"
          [subscriptSizing]="
            screenSize == ScreenType.Mobile ? 'dynamic' : 'dynamic'
          "
        >
          <mat-label>Search</mat-label>
          <input matInput (keyup)="applyFilterCustom($event)" #input2 />
          <!-- <mat-icon matPrefix>search</mat-icon> -->
        </mat-form-field>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content class="incident-table-card-content">
    <div
      class="incident-table-description"
      *ngIf="screenSize != ScreenType.Mobile && false"
    >
      <h4>Top {{ temp ? temp.length : 0 }}</h4>
      <div>
        <button (click)="onRefreshIncidet()" mat-raised-button>
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
    <div
      *ngIf="filteredDataSource.data.length == 0 && false"
      class="no-data-available"
    >
      No Data Available <mat-divider></mat-divider>
    </div>
    <div class="search-box-container">
      <!-- Enhanced Filter Section -->
      <div class="filters-row">
        <!-- Primary Filter -->
        <mat-form-field
          [ngStyle]="
            screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
          "
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>Filter By</mat-label>
          <mat-select
            [value]="selectedPrimaryFilter"
            (selectionChange)="onPrimaryFilterChange($event)"
          >
            <mat-option value="all">All</mat-option>
            <mat-option value="my-issues">My Issues</mat-option>
            <mat-option value="assigned-to">Assigned To</mat-option>
            <mat-option value="reported-by">Reported By</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- My Issues Sub-filter -->
        <mat-form-field
          *ngIf="selectedPrimaryFilter === 'my-issues'"
          [ngStyle]="
            screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
          "
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>My Issues Type</mat-label>
          <mat-select
            [value]="selectedMyIssuesType"
            (selectionChange)="onMyIssuesTypeChange($event)"
          >
            <mat-option value="all">All</mat-option>
            <mat-option value="reported">Reported by Me</mat-option>
            <mat-option value="assigned">Assigned to Me</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Assigned To Multi-select -->
        <!-- Assigned To Multi-select -->
        <mat-form-field
          *ngIf="selectedPrimaryFilter === 'assigned-to'"
          [ngStyle]="
            screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
          "
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>Assigned Users</mat-label>
          <mat-select
            multiple
            [value]="selectedAssignedUsers"
            (selectionChange)="onAssignedUsersChange($event)"
          >
            <mat-option
              *ngFor="let user of availableAssignedUsers"
              [value]="user.userId"
            >
              {{ user.userName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Reported By Multi-select -->
        <mat-form-field
          *ngIf="selectedPrimaryFilter === 'reported-by'"
          [ngStyle]="
            screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
          "
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>Reporters</mat-label>
          <mat-select
            multiple
            [value]="selectedReporters"
            (selectionChange)="onReportersChange($event)"
          >
            <mat-option
              *ngFor="let reporter of availableReporters"
              [value]="reporter"
            >
              {{ reporter }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Status Filter -->
        <mat-form-field
          [ngStyle]="
            screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
          "
          subscriptSizing="dynamic"
          appearance="outline"
        >
          <mat-label>Incident Status</mat-label>
          <mat-select
            [value]="selectedStatus"
            (selectionChange)="onChangeDataTable($event)"
          >
            <mat-option value="-1">All</mat-option>
            <mat-option value="0">Open</mat-option>
            <mat-option value="1">Close</mat-option>
            <mat-option value="2">Verified</mat-option>
            <mat-option value="3">Snooze</mat-option>
            <mat-option value="4">In-progress</mat-option>
            <mat-option value="8">Completed</mat-option>
            <mat-option value="5">On-hold</mat-option>
            <mat-option value="6">Approved</mat-option>
            <mat-option value="7">Rejected</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Search Input -->
      <div class="search-input-row">
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-label>Search</mat-label>
          <input matInput (keyup)="applyFilterCustom($event)" #input />
        </mat-form-field>

        <!-- Clear Filters Button -->
        <button
          mat-stroked-button
          color="primary"
          (click)="clearAllFilters()"
          class="clear-filters-btn"
        >
          <mat-icon>clear</mat-icon>
          Clear Filters
        </button>
      </div>
    </div>
    <div class="visitors-table" *ngIf="screenSize != ScreenType.Mobile">
      <table
        mat-table
        [dataSource]="filteredDataSource"
        matSort
        multiTemplateDataRows
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
      >
        <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef cdkDrag>No.</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ i + 1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Incident Name
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.incidentName }}
            {{
              row.isANPR || row.isFaceMatch
                ? ": " + row.incidentDescription
                : ""
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Date
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            <!-- {{ row.eventCreateDate | date : "full" }} -->
            {{ row.eventCreateDate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Details">
          <th
            style="text-align: center"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          >
            Details
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            <button
              [disabled]="isShowDetails && expandedDetail == element.incidentId"
              (click)="onShowDetails(element)"
              mat-raised-button
            >
              <mat-icon *ngIf="expandedDetail != element.incidentId"
                >add</mat-icon
              >
              <mat-icon
                *ngIf="isShowDetails && expandedDetail == element.incidentId"
                >remove</mat-icon
              >
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="time">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Time
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ getFormatedDate(row.eventCreateDate) | date : "hh:mm a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="asset">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Assigned
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.assignedTo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="reporter">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Reporter
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.eventCreatedBy }}
          </td>
        </ng-container>
        <ng-container matColumnDef="evidence">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Evidence
          </th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let row"
          >
            <img [src]="row.eventEvidence" />
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            cdkDrag
          >
            Status
          </th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let row"
          >
            <button
              [disabled]="row.incidentStatus == 3"
              (click)="onClickStatus(row)"
              mat-raised-button
              [ngStyle]="
                row.incidentStatus == 3
                  ? { 'background-color': '#ffbf00' }
                  : row.incidentStatus == 0 || row.incidentStatus == 8
                  ? { 'background-color': 'green' }
                  : row.incidentStatus == 1
                  ? { 'background-color': 'red' }
                  : { 'background-color': 'gray' }
              "
              mat-raised-button
            >
              {{
                row.incidentStatus == 1
                  ? "Closed"
                  : row.incidentStatus == 0
                  ? "Open"
                  : row.incidentStatus == 2
                  ? "Verified"
                  : row.incidentStatus == 3
                  ? "Snoozed"
                  : row.incidentStatus == 4
                  ? "In-Progress"
                  : row.incidentStatus == 5
                  ? "On-Hold"
                  : row.incidentStatus == 6
                  ? "Approved"
                  : row.incidentStatus == 7
                  ? "Rejected"
                  : row.incidentStatus == 8
                  ? "Completed"
                  : ("Not Specified" | titlecase)
              }}
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="details">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          ></th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let element"
          >
            <!-- <button (click)="onShowDetails(element)" mat-raised-button>
              <mat-icon>add</mat-icon>
            </button> -->
            <!-- <button
              [disabled]="element.incidentStatus == '3'"
              (click)="onSnoozeIncident(element)"
              mat-raised-button
            >
              {{ element.incidentStatus == "3" ? "Snoozed" : "Snooze" }}
            </button> -->
          </td>
        </ng-container>
        <tr
          class="table-header"
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <!-- <div class="not-matched" *ngIf="!!filteredDataSource && !!temp.length">
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">
              No data matching the filter "{{ input2.value }}"
            </td>
          </tr>
        </div> -->
      </table>
      <div class="data-not-found" *ngIf="!temp.length">
        {{ "No Incident Data available" | uppercase }}
      </div>
    </div>
    <div class="mobile-table-card" *ngIf="screenSize === ScreenType.Mobile">
      <app-mobile-table-card
        [incidentTableData]="filteredDataSource.data"
        [tableType]="'incident'"
        (showDetails)="onShowDetails($event)"
        (snoozeIncident)="onClickStatus($event)"
      ></app-mobile-table-card>
    </div>
  </mat-card-content>
</mat-card>
